module.exports = __webpack_public_path__ + "static/media/favicon-32.557a63d1.png";